/** GrowthBook flags referenced by {@link TOOL_DEFINITIONS} entries. */
export const TOOL_FEATURE_FLAG_VIDEO_UNCENSORED = 'video_uncensored'

export const TOOL_FEATURE_FLAG_YOUTUBE_THUMBNAIL_GENERATOR = 'studio-youtube-thumbnail-generator'
